//Built-in libraries
import { useState } from 'react';
import { useParams } from 'react-router';

//Third party libraries

import { EllipsisVerticalIcon, PencilIcon } from '@heroicons/react/24/solid';

//Custom components
import DropDown, { type DropDownMenuItem } from '@/components/UI/DropDown';
//Services
import { usePermission } from '../../../../../../../hooks/usePermission';
import ChangeProjectSocialGoals from './ChangeProjectSocialGoals';
import UpdateProjectSources from './UpdateProjectSources';
import UpdateProjectSubsidies from './UpdateProjectSubsidies';
import UpdateProjectUses from './UpdateProjectUses';

//Assets and Miscellaneous

const ProjectIDSettings = () => {
  const { projectId } = useParams<string>();
  const { hasPermission } = usePermission();
  const [isEditing, setIsEditing] = useState<{ [key: string]: boolean }>({
    projectBaseline: false,
    projectUses: false,
    projectSources: false,
    projectGoals: false,
    projectSubsidies: false,
  });

  const dropDownProjectItemModalHandler = (name: string) => {
    if (name === 'projectDraws') {
      window.open(`/app/sherpa/projects/${projectId}/idms`, '_blank');
    } else if (name === 'projectChangeOrders') {
      window.open(`/app/sherpa/projects/${projectId}/change-order`, '_blank');
    } else {
      setIsEditing((prevState) => ({
        ...prevState,
        [name]: !prevState[name],
      }));
    }
  };

  const EditButtonDropDownItems: DropDownMenuItem[] = [
    {
      name: 'Add/Edit Sources',
      clicked: () => dropDownProjectItemModalHandler('projectSources'),
      icon: <PencilIcon className='h-5 w-5' />,
      permission: {
        of: 'UPDATE_PROJECT_SOURCE',
      },
    },
    {
      name: 'Add/Edit Uses',
      clicked: () => dropDownProjectItemModalHandler('projectUses'),
      icon: <PencilIcon className='h-5 w-5' />,
      permission: {
        of: 'UPDATE_PROJECT_SOURCE',
      },
    },
    {
      name: 'Add/Edit Social Goals',
      clicked: () => dropDownProjectItemModalHandler('projectGoals'),
      icon: <PencilIcon className='h-5 w-5' />,
      permission: {
        of: 'UPDATE_PROJECT',
      },
    },
    {
      name: 'Add/Edit Subsidies',
      clicked: () => dropDownProjectItemModalHandler('projectSubsidies'),
      icon: <PencilIcon className='h-5 w-5' />,
      permission: {
        of: 'UPDATE_PROJECT',
      },
    },
    {
      name: 'Add/Edit Draws',
      clicked: () => dropDownProjectItemModalHandler('projectDraws'),
      icon: <PencilIcon className='h-5 w-5' />,
      permission: {
        of: 'LIST_PROJECT_DRAWS',
      },
    },
    {
      name: 'Add/Edit Change Orders',
      clicked: () => dropDownProjectItemModalHandler('projectChangeOrders'),
      icon: <PencilIcon className='h-5 w-5' />,
    },
  ];

  return (
    <>
      {isEditing.projectSources && <UpdateProjectSources handleModal={() => dropDownProjectItemModalHandler('projectSources')} />}
      {isEditing.projectUses && <UpdateProjectUses handleModal={() => dropDownProjectItemModalHandler('projectUses')} />}
      {isEditing.projectGoals && <ChangeProjectSocialGoals handleModal={() => dropDownProjectItemModalHandler('projectGoals')} />}
      {isEditing.projectSubsidies && <UpdateProjectSubsidies handleModal={() => dropDownProjectItemModalHandler('projectSubsidies')} />}
      {hasPermission([
        'UPDATE_PROJECT',
        'ARCHIVE_PROJECT',
        'UPDATE_PROJECT_SOURCE',
        'UPDATE_PROJECT_STATUS',
        'READ_PROJECT',
        'LIST_PROJECT_DRAWS',
      ]) && (
        <div className='absolute right-0 -top-2 z-10'>
          <DropDown menuItems={EditButtonDropDownItems}>
            <div className='hover:text-primaryColor-light cursor-pointer transition duration-300 ease-in-out text-primaryColor-normal gap-2'>
              <EllipsisVerticalIcon className='h-7 w-7 ' />
            </div>
          </DropDown>
        </div>
      )}
    </>
  );
};

export default ProjectIDSettings;
